import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { CustomHttp } from "../../../common/customHttp.service";
import { ApiUrl } from "../../../common/apiUrls";
import { MainAppComponent } from "../../../layout/layout.component";
import { CustomerModel } from "../../../common/viewModels/Admin/CustomerModel";
import {
  LeadStatusTypeModel,
  SubmittedSampleModel,
  SubmittedSamplesFilterModel,
} from "../../../common/viewModels/Analysis/SubmittedSampleModel ";
import { LeadStatusTypesEnum } from "../../../common/enumcontainer.enum";
import { PagerService } from "../../../common/pagerService";

@Component({
  selector: "app-submittedsampleList",
  templateUrl: "./submittedsampleList.component.html",
  styleUrls: ["./submittedsampleList.component.scss"],
})
export class SubmittedsampleList implements OnInit {
  submittedSamplesList: SubmittedSampleModel[] = [];
  customerList: CustomerModel[] = [];
  leadStatusList: LeadStatusTypeModel[] = [];
  isNoRecords: boolean = false;
  pager: any = {};
  length: number = 0;
  filter: SubmittedSamplesFilterModel = {
    CustomerId: null,
    LeadStatusTypeId: null,
    FromDate: null,
    ToDate: null,
    PageNo: 0,
    PageSize: 10,
  };
  LeadStatusTypesEnum = LeadStatusTypesEnum;

  constructor(
    private _http: CustomHttp,
    private _appUrl: ApiUrl,
    private _mApp: MainAppComponent,
    private _toastrService: ToastrService,
    private _pageSrvc: PagerService,
  ) {}

  ngOnInit() {
    this.pager.pageSize = this._mApp.pageSize;
    this.pager.pageIndex = 0;
    this.pager.pageSizeOptions = this._pageSrvc.pageSizeOptions;
    this.GetCustomers();
    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
    if (curUserDetails && curUserDetails.DefaultCompanyId && curUserDetails.UserTypeId == 3) {
      this.filter.CustomerId = parseInt(curUserDetails.DefaultCompanyId);
    }
    this.GetLeadStatusTypes();
    // this.GetLeadStatusTypes();
    this.GetSubmittedSamplesList(this.pager);
  }

  setPage(page: any) {
    this.pager.pageSize = page.pageSize;
    this.pager.pageIndex = page.pageIndex;
    this.GetSubmittedSamplesList(this.pager);
  }

  formatDate(date: any): string | null {
    if (!date) return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = ("0" + (d.getMonth() + 1)).slice(-2);
    const day = ("0" + d.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  GetSubmittedSamplesList(page?: any) {
    if (
      this.filter.FromDate &&
      this.filter.ToDate &&
      new Date(this.filter.ToDate) < new Date(this.filter.FromDate)
    ) {
      this._toastrService.error(
        "To Date should not be less than From Date",
        "",
      );
      return;
    }
    this._mApp.ShowLoader();
    if (page) {
      this.filter.PageNo = page.pageIndex;
      this.filter.PageSize = page.pageSize;
    }
    const payload = {
      ...this.filter,
      FromDate: this.formatDate(this.filter.FromDate),
      ToDate: this.formatDate(this.filter.ToDate),
    };
    this._http.post(this._appUrl.GetSubmittedSamplesList, payload).subscribe(
      (res) => {
        this._mApp.HideLoader();
        var data = res.json();
        this.submittedSamplesList = data.Result;
        this.length = data.PageResult.TotalRecords;
        this.isNoRecords = !(data.Result.length > 0);
      },
      (error) => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, "");
        this.submittedSamplesList = [];
        this.isNoRecords = true;
      },
    );
  }

  GetCustomers() {
    this._http.get(this._appUrl.GetCustomersMinInfoList).subscribe(
      (data) => {
        this.customerList = data.json().Result;
      },
      (error) => {
        this._toastrService.error(error.json().Result, "");
      },
    );
  }

  GetLeadStatusTypes() {
    
  this._http.get(this._appUrl.GetLeadStatusType)
    .subscribe(
      (data) => {
        this.leadStatusList = data.json().Result;
      },
      (error) => {
        this._toastrService.error(error.json().Result,"");
      }
    );
}

  UpdateLeadStatus(sampleId: number, statusType: number) {
    this._mApp.ShowLoader();
    this._http
      .post(
        this._appUrl.UpdateLeadStatus +
          "?sampleId=" +
          sampleId +
          "&statusType=" +
          statusType,
        {},
      )
      .subscribe(
        (res) => {
          
          this._mApp.HideLoader();
          this._toastrService.success("Lead status updated successfully", "");
          this.GetSubmittedSamplesList();
        },
        (error) => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, "");
        },
      );
  }

  ClearFilters() {
    this.filter = {
      CustomerId: null,
      LeadStatusTypeId: null,
      FromDate: null,
      ToDate: null,
      PageNo: 0,
      PageSize: 10,
    };
    var currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let curUserDetails = this._mApp.getCurrentUserData(currentUser.token);
    if (curUserDetails && curUserDetails.DefaultCompanyId && curUserDetails.UserTypeId == 3) {
      this.filter.CustomerId = parseInt(curUserDetails.DefaultCompanyId);
    }
    this.pager.pageIndex = 0;
    this.setPage(this.pager);
  }
}
